import styled from 'styled-components';
// Transaction on going modal에 추가된 문구에 적용
const Ul = styled.ul`
  word-break: normal;
  font-size: 14px;
  color: grey;
  border-radius: 4px;
  margin-top: -4px;
  margin-bottom: -10px;
  li {
    display: flex;
    position: left;
    margin: 0;
    padding: 6px 0;
    list-style: none;
    line-height: 18px;
    &::before {
      content: '•';
      margin-right: 12px;
      font-weight: 600;
      font-size: 11px;
    }
  }
`;

export { Ul };
